import _ from 'lodash';
import { IMAGE_ORIENTATION, PAGE_LOAD_STATUS, VIEWER_MODE } from './enums';
import moment from 'moment';

//constants
export const ZOOM_STEP = 0.05;
export const ZOOM_MINIMUM = 0.05;
export const ZOOM_MAXIMUM = 10;

//structures
export const INIT_PAGE_PROPERTY = {
    docPageId: '', //doc_and_page
    zoom: 1.0,
    rotation: 0,
    originalOrientation: IMAGE_ORIENTATION.PORTRAIT,
    orientation: IMAGE_ORIENTATION.PORTRAIT,
    originalWidth: 0,
    maW: 300,
    originalHeight: 0,
    maH: 400,
    top: 0,
    left: 0,
    status: PAGE_LOAD_STATUS.NOT_LOADED,
    bookmarks: [],
    comments: [],
    pageRenderVer: 0,
    imageData: null,
};
export const INIT_TAB_TOOLBAR = {
    toolbarId: '', //tab(docId)_and_window
    wideViewSubData: '',
    thumbnailsViewOnPanel: false,
    bookmarksViewOnPanel: false,
    commentsViewOnPanel: false,
    showCommentsPanel: false,
    documentHistoryPanel: false,
    thumbnailsData: {},
    pagesToolbar: {},
    pageCount: 0,
    activePage: 0,
    allBookmarks: [],
    allAnnotations: [],
};
export const INIT_DOC_EMPTY_TAB = {
    tabId: '', //place for tab_ + docId
    tabName: 'empty',
    docType: 'other',
    docTab: 'other',
    docKind: 'EMPTY', // EMPTY, DOCUMENT, ATTENDANCE, ANY!
    tabDocDate: '',
    pagesData: [],
    documentData: {},
    documentAnnotations: [],
    toolbar: _.cloneDeep(INIT_TAB_TOOLBAR),
};
export const INIT_VIEWER = {
    viewerId: 'viewer_0',
    tabs: [],
    activeTab: -1,
    mode: VIEWER_MODE.INITIAL,
    favorites: false,
    filterWindow: false,
    viewFilter: 'all',
};
export const INIT_STATE = {
    // deprecated ( nested structure make troubles with performance, reflects when change anything inside )
    viewer_0: _.cloneDeep(INIT_VIEWER),
    viewer_1: null, //for future use as separate viewer on split view
    viewer_2: null, //for future use as separate viewer on split view
    viewer_3: null, //for future use as separate viewer on split view
    // end
    catalogId: '',
    allDocuments: [],
    spells: [],
    episodes: [],
    attendances: [],
    thumbnails: {},
    docPages: {},
    mode: VIEWER_MODE.INITIAL,
    activeWindow: 0,
    openTabs: [],
    activeTabId: '',
    currentToolbarSet: _.cloneDeep(INIT_TAB_TOOLBAR),
    currentDocPageSet: _.cloneDeep(INIT_PAGE_PROPERTY),
    loading: {
        main: false,
        documents: false,
    },
    filter: {
        panelVisible: false,
        text: null,
    },
};

export const INIT_DOC_UPLOAD_DATA = {
    docDate: moment(),
    docTime: moment(),
    docType: null,
    docTypeValue: '',
    docClass: null,
    docClassValue: '',
    recordType: null,
    recordTypeValue: '',
    accessRole: null,
    accessRoleValue: '',
    storage: null,
    storageValue: '',
    taskValue: '',
    alternativeAttendanceId: '',
    attendanceIds: [''],
    availableAttendances: [],
    referralIds: [''],
};
